import { create } from "zustand";

/**
 * WHO-5531. The sidebar (rendered by AccountLayout, outside the page) shows a
 * small Attention dot on Betaalinstellingen while the dashboard reports an
 * open STRIPE_VERIFICATION action. The dashboard feeds this store; the menu
 * reads it. Nothing else lives here on purpose.
 */
type DashboardIndicatorStore = {
  hasStripeVerificationAction: boolean;
  setHasStripeVerificationAction: (value: boolean) => void;
};

export const dashboardIndicatorStore = create<DashboardIndicatorStore>(set => ({
  hasStripeVerificationAction: false,
  setHasStripeVerificationAction: value =>
    set({ hasStripeVerificationAction: value }),
}));
